// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DemoModal_wrapper__3j_YU","videoController":"DemoModal_videoController__3H-yU"};